import { FORM_BUILDER_FIELD_TYPE } from "@loanbossinc/component-library";

export const rows = {

  title: {
    isTitle: true,
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TEXT,
        value: "Cash Management",
        style: {
          marginLeft: "0",
          fontFamily: "Work Sans",
          fontStyle: "normal",
          fontWeight: "500",
          fontSize: "16px",
          lineHeight: "14px",
          textTransform: "uppercase",
          color: "#000000",
          marginBottom: "10px"
        }
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.cashmanagement.header"
      }
    ]
  },
  cashManagementEvent: {
    label: "Cash Management Event",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "covenants.cashSweepConditions",
        variant: "filled",
        multiline: true
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.covenants.cashSweepConditions"
      }
    ]
  },
  cashManagementCure: {
    label: "Cash Management Cure",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "covenants.cashManagementCure",
        variant: "filled",
        multiline: true
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.covenants.cashManagementCure"
      }
    ]
  },
  cashManagementAccount: {
    label: "Cash Management Account",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "covenants.cashSweepAccount",
        variant: "filled",
        multiline: true
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.covenants.cashSweepAccount"
      }
    ]
  },
  applicationOfFunds: {
    label: "Application of Funds",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "covenants.applicationOfFunds",
        variant: "filled",
        multiline: true
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.covenants.applicationOfFunds"
      }
    ]
  },
  misc: {
    label: "Misc.",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "covenants.cashManagementMisc",
        variant: "filled",
        multiline: true
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.covenants.cashManagementMisc"
      }
    ]
  }
};
